/**
 * Información sobre una pantalla de la aplicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export class Screen {
    /**
     * Nombre de la pantalla
     */
    public name = ''

    /**
     * Ruta
     */
    public path = ''
}
